._BlankNav_1f21g_1 {
  align-items: center;
  background-color: var(--brand-dark);
  display: flex;
  height: 4em;
  padding: 1rem;
}
